import { css, styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

import { DIVIDER_SPACING, ICON_BUTTON_SIZE } from './getActionPanelWidth'

/**
 * Row actions, ellipsis, overlay close, header chevron.
 */
export const panelIconButtonStyles = css`
  align-items: center;
  background: ${Colors.Semantic.Neutral.white};
  border: 1px solid ${Colors.Semantic.Neutral.medium_grey};
  border-radius: 0.25rem;
  color: ${Colors.Semantic.BStock.default.lightBackground};
  cursor: pointer;
  display: flex;
  height: var(--panel-icon-button-size);
  justify-content: center;
  padding: 0;
  width: var(--panel-icon-button-size);
`

/**
 * An action icon button: the menu's actions, and the bid overlay's cancel.
 *
 * Header's chevron is not one of these — same square, different hover — so it
 * builds on `panelIconButtonStyles` directly.
 */
export const PanelIconButton = styled.button`
  --panel-icon-button-size: ${ICON_BUTTON_SIZE}px;

  ${panelIconButtonStyles}

  &:hover {
    border-color: ${Colors.Semantic.BStock.default.lightBackground};
  }
`

/**
 * The panel: the action form, then the action menu.
 *
 * Publishes the form's span as a custom property rather than threading a prop
 * down to every form state: `FormRow` and its loading placeholder each need it,
 * and only this element knows the variant. Inheritance does the rest, so a new
 * form state gets the right width by being inside the panel.
 */
export const Panel = styled.div<{ $formWidth: number }>`
  --action-form-width: ${(o) => o.$formWidth}px;

  align-items: center;
  display: flex;
  /* The form's clearance from the divider; the menu carries the other side. */
  gap: ${DIVIDER_SPACING}px;
  height: 100%;
  justify-content: space-between;
  width: 100%;
`

/**
 * The bold first line of a tooltip, above its description. Shared by the menu's
 * icons and the form's collapsed CTAs, which carry the same two strings.
 */
export const TooltipLabel = styled.span`
  display: block;
  font-weight: 700;
`
